import api from "../store/services/api";

export const getTerms = () => api.get("/legal/terms/");

export const getPrivacy = () => api.get("/legal/privacy/");

export const recordConsent = (document_id) =>
  api.post(
    "/legal/consent/",
    { document_id },
    { headers: { "Content-Type": "application/json" } },
  );

export const getMyConsents = () => api.get("/legal/consent/mine/");
